export interface SystemUserDTO {
  accessTypeId          : number;
  branded               : boolean;
  canBypassSystemOwned  : boolean;
  changePasswordOnLogin?: boolean;
  companyId             : number;
  companyName           : string;
  companyTypeId         : number;
  currencySymbol        : string;
  firstname             : string;
  inviewCompanyId       : number;
  inviewUserId          : number;
  isUtelize             : boolean;
  lastLogin?            : Date;
  lastname              : string;
  sessionId             : number;
  systemAdmin           : boolean;
  systemAdminStd        : boolean;
  token                 : any;
  topLevelCompany       : boolean;
  totpEnabled           : boolean;
  totpRequired          : boolean;
  userId                : number;
  userInfoFromInview    : any;
  username              : string;
};

export function SystemUserDTO_EmptyObject(): SystemUserDTO {
  return {
    accessTypeId         : 0,
    branded              : false,
    canBypassSystemOwned : false,
    changePasswordOnLogin: false,
    companyId            : 0,
    companyName          : "",
    companyTypeId        : 0,
    currencySymbol       : "£",
    firstname            : "",
    inviewCompanyId      : 0,
    inviewUserId         : 0,
    isUtelize            : false,
    lastname             : "",
    sessionId            : 0,
    systemAdmin          : false,
    systemAdminStd       : false,
    token                : "",
    topLevelCompany      : false,
    totpEnabled          : false,
    totpRequired         : false,
    userId               : 0,
    username             : "",
    userInfoFromInview   : undefined
  }
};
